module.exports = __webpack_public_path__ + "static/media/general-de-seguros-checkmark.a2bb0d38.svg";